<ng-container *transloco="let t">
    <br>
    <div class="breadcrumb-container">
        <nav class="breadcrumb">
            <a routerLink="/user/region">Region</a>
            <span class="separator">/</span>
            <a routerLink="/reference/category">Modules Category</a>
            <span class="separator">/</span>
            <a>Modules</a>
        </nav>
    </div>
    <mat-card style="margin-bottom: 5px;">
        <mat-card-header>
            <mat-card-title style="color: #ea7600; font-size: bold;">ALP CERTIFIED NORMATIVE &amp; TECHNICAL
                REFERENCES</mat-card-title>
        </mat-card-header>
        <mat-card-content style="margin-left: 15px;">
            <ol>
                <li *ngFor="let ref of references">
                    <a [routerLink]="ref.route" style="color: blue; text-decoration: underline;">{{ ref.code }} — {{
                        ref.desc }}</a>
                </li>
            </ol>
        </mat-card-content>
    </mat-card>
    <h3 class="org-header">
        <mat-icon class="org-header-icon">business</mat-icon>
        {{ t('Organization') | uppercase }} - {{ selectedOrgName }}
    </h3>
    <div class="tiles-wrapper">
        <div class="tile-card" *ngFor="let tile of tiles" [ngStyle]="{ backgroundColor: tile.color }"
            (click)="goToTileDetail(tile)" style="cursor: pointer;">
            <div fxLayout="row" fxLayoutAlign="start center" class="tile-header"
                [ngStyle]="{ backgroundColor: tile.color }">
                <span fxFlex class="tile-title" style="cursor: default;">{{ tile.title }}</span>
                <mat-icon fxFlex="initial" style="cursor: default;">{{ tile.icon }}</mat-icon>
            </div>

            <div class="tile-content">
                <p class="tile-description">{{ tile.description }}</p>
            </div>

            <div class="tile-footer">
                <a (click)="goToTileDetail(tile)" class="view-link" class="clickable-icon">
                    {{ t('DocumentArchive.view') }}
                </a>
                <span style="padding-left: 145px;">Pending: {{ tile.documentCount || 0 }}</span>
            </div>
        </div>
    </div>
</ng-container>